"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuleSetRevisionMapFromAccountData = exports.getRuleSetRevisionMapSerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const generated_1 = require("../generated");
const getRuleSetRevisionMapSerializer = (location) => ({
    description: 'RuleSetRevisionMap',
    fixedSize: null,
    maxSize: null,
    serialize: (revisionMap) => {
        if (revisionMap.version !== 1) {
            throw new Error(`Unsupported revision map version: ${revisionMap.version}`);
        }
        const revisionMapV1 = (0, generated_1.getRuleSetRevisionMapV1Serializer)().serialize({
            ruleSetRevisions: revisionMap.revisionLocations.map((n) => BigInt(n)),
        });
        return (0, serializers_1.mergeBytes)([new Uint8Array([revisionMap.version]), revisionMapV1]);
    },
    deserialize: (buffer, offset = 0) => {
        const version = Number(buffer[offset]);
        if (version !== 1) {
            throw new Error(`Unsupported revision map version: ${version}`);
        }
        const [revisionMapV1, newOffset] = (0, generated_1.getRuleSetRevisionMapV1Serializer)().deserialize(buffer, offset + 1);
        const revisionLocations = revisionMapV1.ruleSetRevisions.map((n) => Number(n));
        return [{ version, location, revisionLocations }, newOffset];
    },
});
exports.getRuleSetRevisionMapSerializer = getRuleSetRevisionMapSerializer;
const getRuleSetRevisionMapFromAccountData = (accountData) => {
    const [header] = (0, generated_1.getRuleSetHeaderSerializer)().deserialize(accountData);
    const location = Number(header.revMapVersionLocation);
    const [revisionMap] = (0, exports.getRuleSetRevisionMapSerializer)(location).deserialize(accountData, location);
    return revisionMap;
};
exports.getRuleSetRevisionMapFromAccountData = getRuleSetRevisionMapFromAccountData;
//# sourceMappingURL=revisionMap.js.map